var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Record',{attrs:{"title":_vm.featureFlag.key}},[_c('Set',{attrs:{"label":_vm.$t('active')}},[_c('Field',{attrs:{"isSwitch":true,"type":"checkbox","value":_vm.featureFlag.isOn},on:{"update:value":_vm.setIsOn}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }